import React from "react";
import DocumentationSidebar from "../component/DocumentationSidebar";
import { useDocImage } from '../hooks/useDocImage';
import { useTranslation } from 'react-i18next';

// import listWebhookImage from '../assetes/images/webhook/webhook-list.png';

export default function WebhookDocumentation() {
  const { t } = useTranslation();
  const image001 = useDocImage('webhooks-img', 'image-001.png');
  const image002 = useDocImage('webhooks-img', 'image-002.png');
  const image003 = useDocImage('webhooks-img', 'image-003.png');

  return (
    <div className="d-flex flex-column main-outer-wrapper">
      <div className="flex-grow-1 d-flex survey-main-wrapper">
        <DocumentationSidebar />

        {/* Dashboard Content */}
        <div className="flex-grow-1 dashboard-page-outer">
          <div className="dashboard-page-wrap document-page-wrap">
            <h1 className="mt-0 text-primary">{t('documentation.webhooks.title')}</h1>
            <p className="header-para">{t('documentation.webhooks.intro')}</p>

            {/* Section: Accessing Webhook */}
            <div className="card dashboard-card mb-4">
              <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                {t('documentation.webhooks.accessing.title')}
              </div>
              <div className="card-body">
                <ul>
                  <li>{t('documentation.webhooks.accessing.steps.step1')}</li>
                  <li>{t('documentation.webhooks.accessing.steps.step2')}</li>
                  <li>{t('documentation.webhooks.accessing.steps.step3')}</li>
                </ul>
                <img
                  src={image001}
                  alt={t('documentation.webhooks.accessing.imageAlt')}
                  className="img-fluid pt-20 pb-20"
                />
              </div>
            </div>

            {/* Section: Creating a Webhook */}
            <div className="card dashboard-card mb-4">
              <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                {t('documentation.webhooks.create.title')}
              </div>
              <div className="card-body">
                <p>{t('documentation.webhooks.create.intro')}</p>
                <ul>
                  <li>{t('documentation.webhooks.create.fields.name')}</li>
                  <li>
                    {t('documentation.webhooks.create.fields.eventsTitle')}
                    <ul className="pt-2">
                      <li>{t('documentation.webhooks.create.fields.eventLeadForm')}</li>
                      <li>{t('documentation.webhooks.create.fields.eventResponse')}</li>
                      <li>{t('documentation.webhooks.create.fields.eventSurvey')}</li>
                    </ul>
                  </li>
                  <li>
                    {t('documentation.webhooks.create.fields.methodTitle')}
                    <ul className="pt-2">
                      <li>{t('documentation.webhooks.create.fields.methodPost')}</li>
                      <li>{t('documentation.webhooks.create.fields.methodGet')}</li>
                      <li>{t('documentation.webhooks.create.fields.methodPutPatch')}</li>
                      <li>{t('documentation.webhooks.create.fields.methodDelete')}</li>
                    </ul>
                  </li>
                  <li>
                    {t('documentation.webhooks.create.fields.contentTypeTitle')}
                    <ul className="pt-2">
                      <li>{t('documentation.webhooks.create.fields.contentJson')}</li>
                      <li>{t('documentation.webhooks.create.fields.contentForm')}</li>
                      <li>{t('documentation.webhooks.create.fields.contentMultipart')}</li>
                      <li>{t('documentation.webhooks.create.fields.contentText')}</li>
                    </ul>
                  </li>
                  <li>
                    {t('documentation.webhooks.create.fields.dataFormatTitle')}
                    <ul className="pt-2">
                      <li>{t('documentation.webhooks.create.fields.dataJson')}</li>
                      <li>{t('documentation.webhooks.create.fields.dataForm')}</li>
                      <li>{t('documentation.webhooks.create.fields.dataQuery')}</li>
                    </ul>
                    <div className="small text-muted mt-1">
                      {t('documentation.webhooks.create.fields.dataFormatNote')}
                    </div>
                  </li>
                  <li>{t('documentation.webhooks.create.fields.url')}</li>
                  <li>{t('documentation.webhooks.create.fields.description')}</li>
                  <li>
                    {t('documentation.webhooks.create.fields.addParameters')}
                    <ul>
                      <li>{t('documentation.webhooks.create.fields.addParametersStep1')}</li>
                      <li>{t('documentation.webhooks.create.fields.addParametersStep2')}</li>
                    </ul>
                  </li>
                  <li>{t('documentation.webhooks.create.fields.generatedUrl')}</li>
                  <li>{t('documentation.webhooks.create.fields.status')}</li>
                  <li>{t('documentation.webhooks.create.fields.actions')}</li>
                  <img
                    src={image002}
                    alt={t('documentation.webhooks.create.imageAlt')}
                    className="img-fluid pt-20 pb-20"
                  />
                </ul>
              </div>
            </div>

            {/* Section: Webhook Listing Page */}
            <div className="card dashboard-card mb-4">
              <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                {t('documentation.webhooks.listing.title')}
              </div>
              <div className="card-body">
                <p>{t('documentation.webhooks.listing.intro')}</p>
                <img
                  src={image003}
                  alt={t('documentation.webhooks.listing.imageAlt')}
                  className="img-fluid pt-20 pb-20"
                />
                <ul>
                  <li>{t('documentation.webhooks.listing.columns.webhook')}</li>
                  <li>{t('documentation.webhooks.listing.columns.url')}</li>
                  <li>{t('documentation.webhooks.listing.columns.status')}</li>
                  <li>{t('documentation.webhooks.listing.columns.action')}</li>
                </ul>
                <ul>
                  <li>{t('documentation.webhooks.listing.search')}</li>
                  <li>{t('documentation.webhooks.listing.sort')}</li>
                </ul>
              </div>
            </div>

            {/* Section: Activation Status */}
            <div className="card dashboard-card mb-4">
              <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                {t('documentation.webhooks.activation.title')}
              </div>
              <div className="card-body">
                <p>{t('documentation.webhooks.activation.intro')}</p>
                <ul>
                  <li>{t('documentation.webhooks.activation.active')}</li>
                  <li>{t('documentation.webhooks.activation.inactive')}</li>
                  <li>{t('documentation.webhooks.activation.note')}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
